export interface IAssignedRating {
  id: number;
  person: number | null;
  rating: number | null;
  program: number | null;
  testSignoutId: number | null;
}

export class AssignedRating implements IAssignedRating {
  id;
  person;
  rating;
  program;
  testSignoutId;

  constructor(config: IAssignedRating) {
    this.id = config.id;
    this.person = config.person;
    this.rating = config.rating;
    this.program = config.program;
    this.testSignoutId = config.testSignoutId;
  }
}
